import './BaseStyles-79fd37c4.css';

var classes = {"BaseStyles":"prc-src-BaseStyles-dl-St"};

export { classes as default };
